module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-dropdown-export-98cb890157f49ccf21f13251a49b328f.svg";